export const IDENTITIES_PATH = '/diam/identities';

export const ADD_ROLE_LABEL = '+ Add role';

export const REMOVE_ROLE_CONFIRM = {
  title: 'Remove role',
  content:
    'You are going to delete some roles from the identity. Are you sure you want to proceed?',
  confirm: 'Yes',
  cancel: 'No',
};

export const DEACTIVATE_CONFIRM = {
  title: 'Deactivate',
  content:
    'Deactivated users do not have access the system and will not be able to login. Are you sure you want to proceed',
  confirm: 'Yes',
  cancel: 'No',
};

export const SUSPEND_ACCESS_CONFIRM = {
  title: 'Suspend Access',
  content:
    'Suspended user will be able to login but will not have access to the Application. Are you sure you want to proceed',
  confirm: 'Yes',
  cancel: 'No',
};

export const REACTIVATE_CONFIRM = {
  title: 'Reactivate',
  content:
    'Reactivated users will have access to the system and will be able to login. Are you sure you want to proceed',
  confirm: 'Yes',
  cancel: 'No',
};

export const RESUME_ACCESS_CONFIRM = {
  title: 'Resume Access',
  content:
    'Resumed users will have access to the system and will be able to login. Are you sure you want to proceed',
  confirm: 'Yes',
  cancel: 'No',
};

const ATTRIBUTE_DESCRIPTIONS: Record<string, string> = {
  'gapi:read': 'View Global API resources and responses.',
  'gapi:write': 'Create and update Global API resources.',
  'gapi:admin': 'Administer API keys and Global API configuration.',
  'dcim:read':
    'Read DCIM inventory, power, and cooling data across every cabinet, cage, and power feed the organization owns, including historical utilization trends and capacity-planning reports exported from the data center.',
  'dcim:write': 'Modify DCIM records and configurations.',
  'facility:access': 'Enter and move within assigned facility spaces.',
  'cabinets:access': 'View and access assigned cabinets.',
  'cabinets:manage': 'Provision and manage cabinet assignments.',
  'equipment:install': 'Install and remove equipment in assigned cabinets.',
  'tickets:execute': 'Work assigned tickets through to completion.',
  'tickets:escalate': 'Escalate tickets to the next support tier.',
  'incidents:manage': 'Create, update, and resolve operational incidents.',
  'vendors:coordinate': 'Coordinate vendor activity and site visits.',
  'reports:read': 'View dashboards and existing reports.',
  'reports:create': 'Create custom reports and saved views.',
  'reports:export': 'Export report data from the platform.',
  'diam:attributes': 'Create and edit DIAM attribute definitions.',
  'diam:modifiers': 'Create and edit DIAM modifier definitions.',
  'diam:platform-roles': 'Create and edit platform-level DIAM roles.',
};

export function getAttributeDescription(attributeId: string): string {
  return ATTRIBUTE_DESCRIPTIONS[attributeId] ?? `Grants ${attributeId} access.`;
}
